var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoldButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27.001,
    viewBox: "0 0 27 27.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bold-button",
    transform: "translate(0 -0.929)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42836",
    "data-name": "Path 42836",
    d: "M21.368.929H5.632A5.652,5.652,0,0,0,0,6.588V22.271A5.652,5.652,0,0,0,5.632,27.93H21.368A5.652,5.652,0,0,0,27,22.271V6.588A5.652,5.652,0,0,0,21.368.929Zm3.569,21.342a3.581,3.581,0,0,1-3.569,3.586H5.632a3.581,3.581,0,0,1-3.569-3.586V6.588A3.581,3.581,0,0,1,5.632,3H21.368a3.581,3.581,0,0,1,3.569,3.586Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42837",
    "data-name": "Path 42837",
    d: "M134.76,105.476h-5.7v2.432h.718v7.759h-.718V118.1h5.7a3.761,3.761,0,0,0,2.767-6.311,3.761,3.761,0,0,0-2.767-6.311Zm0,2.432a1.332,1.332,0,1,1,0,2.663h-2.547v-2.663h2.547Zm0,7.759h-2.547V113h2.547a1.332,1.332,0,1,1,0,2.663Z",
    transform: "translate(-120.236 -97.358)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldButton);
export default __webpack_public_path__ + "static/media/bold-button.b9bd206ba4d4de06e4f3e9e901ca1805.svg";
export { ForwardRef as ReactComponent };